import React, {useEffect, useState} from 'react';

import springboard from 'springboard';

import {useSearchParams} from 'react-router-dom';
import {getSiteUrl} from '@/store/utils/get_site_url';


import '@/modules/music_sniper/components/modals/modals_provider';
import '@/modules/mantine/mantine_module';


import './styles.css';

// import {CustomDropZone} from '@/components/custom_drop_zone';

// import {Button} from '@mantine/core'
import {WithCallOptions, useActions, useSelectorWithRefresh, useSelectors} from '../../store/kysely_module';
import {FileViewPage} from './pages/file_view_page';
import {useEnsureCurrentWorkspaceId} from '../../store/modules/workspaces_module';
import {FileTable} from './components/file_table';
import {useParams} from 'react-router';
import {WorkspaceSelectionPage} from './pages/workspace_selection_page';
import {ProjectSelectionPage} from './pages/project_selection_page';
import {ProjectViewPage} from './pages/project_view_page';

import './components/application_shell/application_shell_module';
import {registerBreadcrumbs} from './components/application_shell/breadcrumbs/breadcrumbs';
import {QRCode} from '@/components/qrcode';
import {NewDashboard} from '@/components/new_dashboard/new_dashboard';
import {NewProjectViewPage} from '@/components/new_project_view_page/new_project_view_page';
import {UserProfilePage} from './pages/user_profile_page';

declare module 'springboard/module_registry/module_registry' {
    interface AllModules {
        MusicSniper: MusicSniperModuleReturnValue;
    }
}

type MusicSniperModuleReturnValue = {

};

springboard.registerModule('MusicSniper', {}, async (moduleAPI): Promise<MusicSniperModuleReturnValue> => {
    moduleAPI.registerRoute('/workspaces', {}, () => {
        useEnsureCurrentWorkspaceId();

        const loginFlowModule = moduleAPI.getModule('LoginFlow');
        useEffect(() => {
            loginFlowModule.resetStoredInvite();
        }, []);

        return (
            <WorkspaceSelectionPage />
        );
    });

    moduleAPI.registerRoute('/dashboard', {}, () => {
        useEnsureCurrentWorkspaceId();

        const loginFlowModule = moduleAPI.getModule('LoginFlow');
        useEffect(() => {
            loginFlowModule.resetStoredInvite();
        }, []);

        return (
            <NewDashboard />
        );
    });

    moduleAPI.registerRoute('/workspaces/:workspaceId/projects', {}, () => {
        const workspaceId = useParams().workspaceId;
        if (!workspaceId) {
            return 'No workspace id in url';
        }

        return (
            <ProjectSelectionPage
                workspaceId={workspaceId}
            />
        );
    });

    registerBreadcrumbs('/workspaces/:workspaceId/projects', (params, data) => {
        const workspaceId = params.workspaceId;
        if (!workspaceId) {
            return [];
        }

        const workspace = data.workspaces?.find(w => w.id === workspaceId);
        if (!workspace) {
            return [];
        }

        return [
            {
                label: workspace.name,
                link: `/workspaces/${workspace.id}/projects`,
            },
        ];
    });

    moduleAPI.registerRoute('/workspaces/:workspaceId/projects/:projectId', {}, () => {
        const params = useParams();
        const projectId = params.projectId;
        if (!projectId) {
            return 'No project id in url';
        }

        const workspaceId = params.workspaceId;
        if (!workspaceId) {
            return 'No workspace id in url';
        }

        return (
            <NewProjectViewPage
                key={projectId}
                projectId={projectId}
                workspaceId={workspaceId}
            />
        );

        // return (
        //     <ProjectViewPage
        //         key={projectId} // TODO: this causes some jumpiness on changing project from sidebar. it's necessary to reload data atm though
        //         project_id={projectId}
        //         workspace_id={workspaceId}
        //     />
        // );
    });

    moduleAPI.registerRoute('/qrcode_invite', {hideApplicationShell: true}, () => {
        const siteUrl = getSiteUrl();
        const [searchParams] = useSearchParams();
        const url = searchParams.get('url') || siteUrl;

        return (
            <div style={{textAlign: 'center'}}>
                <h2>SongDrive</h2>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <QRCode
                        url={url}
                        style={{height: '200px'}}
                    />
                </div>
                <p style={{marginTop: '20px'}}>
                    <a href={url}>
                        {url}
                    </a>
                </p>
            </div >
        )
    });

    registerBreadcrumbs('/workspaces/:workspaceId/projects/:projectId', (params, data) => {
        const projectId = params.projectId;
        if (!projectId) {
            return [];
        }

        const workspaceId = params.workspaceId;
        if (!workspaceId) {
            return [];
        }

        const workspace = data.workspaces?.find(w => w.id === workspaceId);
        const project = data.projects?.find(p => p.id === projectId);

        if (!workspace || !project) {
            return [];
        }

        // Build parent projects from ancestry
        const ancestorIds = project.project_ancestry?.split(',').filter(Boolean) || [];
        const parentProjects = ancestorIds
            .map(ancestorId => data.projects?.find(p => p.id === ancestorId))
            .filter((p): p is NonNullable<typeof p> => !!p)
            .sort((a, b) => {
                const aDepth = a.project_ancestry?.split(',').length || 0;
                const bDepth = b.project_ancestry?.split(',').length || 0;
                return aDepth - bDepth;
            });

        return [
            {
                label: workspace.name,
                link: `/workspaces/${workspace.id}/projects`,
            },
            ...parentProjects.map(parentProject => ({
                label: parentProject.name,
                link: `/workspaces/${parentProject.workspace_id}/projects/${parentProject.id}`,
            })),
            {
                label: project.name,
                link: `/workspaces/${project.workspace_id}/projects/${project.id}`,
                avoidLink: true,
            },
        ];
    });

    registerBreadcrumbs('/workspaces/:workspaceId/files/:fileId', (params, data) => {
        const fileId = params.fileId;
        if (!fileId) {
            return [];
        }

        const workspaceId = params.workspaceId;
        if (!workspaceId) {
            return [];
        }

        const fileInfo = data.fileBreadcrumbInfo;
        if (!fileInfo) {
            return [];
        }

        return [
            {
                label: fileInfo.workspace.name,
                link: `/workspaces/${fileInfo.workspace.id}/projects`,
            },
            ...fileInfo.parent_projects.map(parentProject => ({
                label: parentProject.name,
                link: `/workspaces/${parentProject.workspace_id}/projects/${parentProject.id}`,
            })),
            {
                label: fileInfo.project.name,
                link: `/workspaces/${fileInfo.workspace.id}/projects/${fileInfo.project.id}`,
            },
        ];
    });

    moduleAPI.registerRoute('/workspaces/:workspaceId/files/:fileId', {}, ({navigate}) => {
        const params = useParams();
        const fileId = params.fileId;
        if (!fileId) {
            return 'No file id in url';
        }

        const workspaceId = params.workspaceId;
        if (!workspaceId) {
            return 'No workspace id in url';
        }

        return (
            <FileViewPage
                file_id={fileId}
                workspace_id={workspaceId}
            />
        );
    });

    moduleAPI.registerRoute('/users/:userId/profile', {}, () => {
        const params = useParams();
        const userId = params.userId;
        if (!userId) {
            return 'No user id in url';
        }

        return (
            <UserProfilePage userId={userId} />
        );
    });

    return {
    };
});
